import axios from "axios";
import configuration from "../configuration/configuration";

/**
 * Photos d'une prise en charge (routes /api/prisesencharge/{id}/photos de l'API).
 * L'API donne des liens signés relatifs (url, miniature) : lienPhoto() les préfixe par l'adresse de l'API.
 */
export const lienPhoto = chemin => chemin ? configuration.API + chemin : "";

export default class PhotosPecAPI {

    async liste(pecId) {
        const response = await axios({method: 'get', url: `${configuration.API}/api/prisesencharge/${pecId}/photos`});
        return response.data.photos ?? [];
    }

    async envoyer(pecId, fichier, legende, onProgression) {
        const data = new FormData();
        data.append('photo', fichier);
        if (legende) data.append('legende', legende);

        const response = await axios({
            method: 'POST',
            url: `${configuration.API}/api/prisesencharge/${pecId}/photos`,
            headers: {'content-type': 'multipart/form-data'},
            data,
            onUploadProgress: e => onProgression && e.total && onProgression(Math.round(e.loaded * 100 / e.total))
        });
        return response.data.photo;
    }

    async legende(pecId, photoId, legende) {
        const response = await axios({
            method: 'PUT',
            url: `${configuration.API}/api/prisesencharge/${pecId}/photos/${photoId}`,
            headers: {'content-type': 'application/json'},
            data: {legende}
        });
        return response.data.photo;
    }

    async supprimer(pecId, photoId) {
        await axios({method: 'DELETE', url: `${configuration.API}/api/prisesencharge/${pecId}/photos/${photoId}`});
    }
}
